export const getLocationHeader = (isHideForSalesAndManager?: boolean) => {
  const titles = ['#', 'Size', 'Type', 'Event Type'];

  if (!isHideForSalesAndManager) {
    titles.splice(1, 0, '$');
  }

  return titles;
};
